module.exports = [{
      plugin: require('/Users/kaushal/Downloads/kparikh.github/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1100,"quality":90,"linkImagesToOriginal":true},
    },{
      plugin: require('/Users/kaushal/Downloads/kparikh.github/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-45666519-2"},
    },{
      plugin: require('/Users/kaushal/Downloads/kparikh.github/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
